import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import Content from "./Content";
import { colors } from "../../theme";

const useStyles = makeStyles((theme) => ({
  strong: {
    fontSize: "18px",
    fontWeight: "bold",
    fontStretch: "normal",
    lineHeight: "1.7",
    letterSpacing: "-0.04px",
    color: colors.TEXT_PRIMARY,
  },
  text: {
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.7",
    letterSpacing: "-0.04px",
    color: colors.TEXT_PRIMARY,
  },
  a: {
    textDecoration: "none",
  },
  button: {
    width: "170px",
    backgroundColor: colors.COOKIE_BTN,
    marginTop: "-20px",
    "&:hover": {
      backgroundColor: colors.COOKIE_BTN_HOVER,
    },
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  buttonOutline: {
    width: "170px",
    backgroundColor: colors.BACKGROUND_PRIMARY,
    color: colors.COOKIE_BTN,
    marginTop: "-20px",
    "&:hover": {
      backgroundColor: colors.COOKIE_BTN_HOVER,
      color: colors.BACKGROUND_PRIMARY,
    },
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
}));

export default function Contact() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Content>
      <>
        <strong className={classes.strong}>
          {t("settings.about_cookies")}
        </strong>
        <p className={classes.text}>{t("settings.about_cookies_content")}</p>
      </>
      <>
        <strong className={classes.strong}>
          {t("settings.block_cookies")}
        </strong>
        <p className={classes.text}>{t("settings.block_cookies_content")}</p>
        <p className={classes.text}>{t("settings.block_cookies_content")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("settings.cookies")}</strong>
        <p></p>
      </>
      <>
        <strong className={classes.strong}>{t("settings.popup")}</strong>
        <p className={classes.text}>{t("settings.popup_content")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("settings.analytics")}</strong>
        <p className={classes.text}>{t("settings.analytics_content")}</p>
      </>
      <>
        <strong className={classes.strong}>
          {t("settings.cookie_settings")}
        </strong>
        <p className={classes.text}>{t("settings.cookie_settings_content")}</p>
      </>
      <>
        <strong className={classes.strong}>{t("settings.contact")}</strong>
        <p className={classes.text}>{t("settings.contact_content")}</p>
      </>
    </Content>
  );
}
